'use client'
import { SourceLanguageCode, TargetLanguageCode } from 'deepl-node'
import { createParser, parseAsArrayOf, parseAsBoolean, parseAsString, useQueryStates } from 'nuqs'
import { DELIMITER, defaultSearchParams } from './constants'

export type SearchParams = {
    ftl: TargetLanguageCode[]
    tl: TargetLanguageCode[]
    sl: SourceLanguageCode
    text: string
    langName?: boolean
}

export type SearchParamsEndoced = {
    ftl: string
    tl: string
    sl: string
    text: string
    langName?: boolean
}

export const toSearchParams = (params: SearchParams): SearchParamsEndoced => {
    return {
        tl: params.tl.join(DELIMITER),
        ftl: params.ftl.join(DELIMITER),
        sl: params.sl,
        text: params.text,
        langName: params.langName,
    }
}

export const tlParser = createParser({
    parse: (query: string) => query as TargetLanguageCode,
    serialize: (value: TargetLanguageCode) => value,
})

export const slParser = createParser({
    parse: (query: string) => query as SourceLanguageCode,
    serialize: (value: SourceLanguageCode) => value,
})

export const tlArrayParser = parseAsArrayOf(tlParser, DELIMITER).withDefault(
    defaultSearchParams.tl.split(DELIMITER) as TargetLanguageCode[]
)

export const useAllQueryStates = () => {
    return useQueryStates({
        tl: tlArrayParser,
        ftl: tlArrayParser,
        sl: slParser.withDefault(defaultSearchParams.sl as SourceLanguageCode),
        text: parseAsString.withDefault(''),
        langName: parseAsBoolean.withDefault(false),
    })
}
